import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
  const fm = newFormat || 'DD MMM YYYY';

  return date ? dayjs(date).format(fm) : '';
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'DD MMM YYYY h:mm A';

  return date ? dayjs(date).format(fm) : '';
}

export function fTimestamp(date) {
  return date ? dayjs(date).valueOf() : '';
}

export function fToNow(date) {
  return date ? dayjs(date).fromNow() : '';
}
